var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenovationprocess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.793 21.63c8.26 0 23.794-3.253 23.794-10.815C47.587 4.953 36.69 0 23.793 0S0 4.953 0 10.815C0 16.677 10.896 21.63 23.793 21.63zm-.987-18.37a2.982 2.982 0 012.157-1.72 2.929 2.929 0 011.274.038A24.709 24.709 0 0134 4.803c2.527 1.707 4.915 4.576 3.478 7.222-2.869 5.28-13.716 5.28-13.717 5.28-5.374 0-14.026-1.88-14.026-7.03 0-3.82 5.563-6.769 13.072-7.014z",
    fill: "url(#paint0_linear_303_6376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.787 15.066l.691-9.626c-6.293.303-10.581 2.696-10.581 4.834 0 2.046 3.93 4.36 9.89 4.792zm8.19-9.972a29.256 29.256 0 00-4.278-1.417.798.798 0 00-.973.722v.02l-.778 10.722a24.43 24.43 0 005.555-.631l.473-9.416zm-1.858 5.721a1.081 1.081 0 11-2.163 0V9.734a1.082 1.082 0 112.163 0v1.081zm7.401.284c.742-1.564-1.298-3.532-2.734-4.504-.228-.154-.46-.301-.697-.442l-.388 7.69c2.026-.757 3.315-1.681 3.82-2.745zM26.45 52.52a2.525 2.525 0 00-2.009-.432 4.692 4.692 0 01-5.313-3.84 2.533 2.533 0 00-3.047-2.194 4.651 4.651 0 01-3.209-.682 716.43 716.43 0 01-2.858 2 2.163 2.163 0 00-.117 3.46l10.868 8.69a2.163 2.163 0 002.642.052 152.15 152.15 0 004.694-3.647 5.89 5.89 0 01-.61-1.638 2.52 2.52 0 00-1.04-1.768zm-5.056 3.312a1.08 1.08 0 01-1.521.169l-5.408-4.326a1.082 1.082 0 011.352-1.69l5.408 4.327a1.082 1.082 0 01.168 1.52z",
    fill: "url(#paint1_linear_303_6376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.834 5.135a13.899 13.899 0 00-3.27-2.191c2.847 1.89 5.236 4.588 5.186 7.989a8.23 8.23 0 01-2.245 5.252C41.962 23.829 27.26 35.142 14.95 43.902c.324.031.649.03.973-.006a4.66 4.66 0 015.306 3.821 2.565 2.565 0 003.056 2.214 4.68 4.68 0 015.306 3.831c.06.254.136.505.227.75a147.585 147.585 0 004.687-4.055l-4.927-4.212a1.08 1.08 0 111.406-1.643l5.108 4.371a136.387 136.387 0 004.427-4.315l-4.453-3.821a1.08 1.08 0 01.61-1.927 1.082 1.082 0 01.796.285l4.543 3.894a121.018 121.018 0 003.294-3.61c.28-.324.567-.648.856-.984l-3.224-3.686a1.08 1.08 0 01.466-1.742 1.083 1.083 0 011.162.318l3.017 3.445a40.853 40.853 0 003.482-4.785l-2.153-3.028a1.083 1.083 0 011.456-1.544c.12.075.224.174.307.29l1.538 2.162a16.588 16.588 0 001.529-4.92c.86-6.414-.63-15.044-5.912-19.87z",
    fill: "url(#paint2_linear_303_6376)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.734 36.771v-5.407a1.082 1.082 0 112.163 0v6.056a41.47 41.47 0 005.407 1.075v-6.05a1.082 1.082 0 112.163 0v5.508A222.71 222.71 0 0040.44 20.846a44.429 44.429 0 01-16.646 2.947c-10.78 0-19.824-3.128-23.793-7.707V28.12c0 1.898 1.19 3.73 3.245 5.333V28.12a1.081 1.081 0 012.163 0v6.759c1.382.76 2.83 1.393 4.326 1.893z",
    fill: "url(#paint3_linear_303_6376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_6376",
    x1: 0,
    y1: 10.815,
    x2: 47.587,
    y2: 10.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_6376",
    x1: 9.088,
    y1: 31.829,
    x2: 35.678,
    y2: 31.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_6376",
    x1: 14.951,
    y1: 28.728,
    x2: 53.974,
    y2: 28.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_6376",
    x1: 0,
    y1: 27.291,
    x2: 40.439,
    y2: 27.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenovationprocess);
export default __webpack_public_path__ + "static/media/Renovationprocess.087812ae491dcedb153f2e86ff65a4a1.svg";
export { ForwardRef as ReactComponent };